<template>
    <div class="video flex flex-column">
        <dark-header></dark-header>
        <div class="flex flex-between player-container">
            <component :is="realComponent" class="flex-item player" :video="video"></component>
        </div>
    </div>
</template>

<script>
import DarkHeader from '@components/DarkHeader.vue';
import AliPlayer from '@components/live/AliPlayer.vue';
import { getVideoDetail } from '@api/liveList';
import PlaybackPlayer from '@components/live/PlaybackPlayer.vue';
import moment from 'moment';
import { reportVideoTime } from '@api/common';

export default {
    components: { DarkHeader, AliPlayer, PlaybackPlayer },
    data() {
        return {
            playbackPlayerOptions: {
                autoplay: true,
                cover: '',
                vid: '',
                playauth: '',
                encryptType: 1 // 当播放私有加密流时需要设置。
            },
            loading: true,
            video: {},
            startTime: moment()
        };
    },
    computed: {
        realComponent() {
            const { watch_back } = this.video;
            if (watch_back === 1) {
                return 'AliPlayer';
            } else if (watch_back === 0) {
                return 'PlaybackPlayer';
            }
            return '';
        }
    },
    created() {
        this.init();
    },
    beforeDestroy() {
        const { video } = this;
        if (video.id) {
            this.$trackEvent('视频回放', '退出视频回放', video.id);
            this.reportVideoDuration();
            window.removeEventListener('beforeunload', this.reportVideoDuration);
        }
    },
    methods: {
        async init() {
            await this.getVideoDetail();
            window.addEventListener('beforeunload', this.reportVideoDuration);
        },
        async getVideoDetail() {
            const { data } = await getVideoDetail(this.$route.query.id);
            this.video = data;
        },
        reportVideoDuration() {
            if (this.$store.getters.token) {
                const { startTime, video } = this;
                reportVideoTime({
                    schedule_id: video.id,
                    duration: moment().toDate().valueOf() - startTime.toDate().valueOf(),
                    start_time: startTime.format('YYYY-MM-DD HH:mm:ss')
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.video {
    width: 100%;
    height: 100vh;
    position: relative;
}
</style>
